/**
 * God of Creation - Game Core Exports
 */

import { GameCore } from '@app-games/core';
import { createInitialState } from './state.js';
import { actionHandlers } from './actions.js';
import { playTimeSystem } from './systems/playTimeSystem.js';
import { combineSystem } from './systems/combineSystem.js';
import { energySystem } from './systems/energySystem.js';
import type { GameState } from './state.js';
import type { GameAction } from './actions.js';

export type { GameState } from './state.js';
export type { GameAction } from './actions.js';

export function createGameCore(debug = false) {
  const core = new GameCore<GameState, GameAction>({
    createInitialState,
    debug,
    historySize: 100
  });

  for (const [type, handler] of Object.entries(actionHandlers)) {
    core.registerAction(type as GameAction['type'], handler as any);
  }

  core.registerSystem(playTimeSystem);
  core.registerSystem(combineSystem);
  core.registerSystem(energySystem);

  return core;
}
